const pagesMarketplaceEn = {
  addShippingAddressManually: 'Add Shipping Address Manually',
  addToCart: 'Add to cart',
  addedToCartDialog: {
    addedToCart: 'Added To Cart!',
    backToStore: 'Back to Store',
    goToCart: 'Go to Cart',
  },
  addingToCart: 'Adding...',
  address: 'Address',
  agreementDate: 'Agreement date',
  all: 'All',
  amountToPay: 'Amount to pay',
  approved: 'Approved',
  backToPlaceSelection: 'Back to Place Selection',
  canceled: 'Canceled',
  cancellationDate: 'Cancellation date',
  cart: 'Cart',
  confirmOrderSuccess: 'Order confirmed',
  confirmed: 'Confirmed',
  contractType: 'Contract Type',
  customer: 'Customer',
  delivery: 'Delivery',
  description: 'Description',
  details: 'Details',
  deviceMarket: 'Device Market',
  deviceType: 'Device Type',
  emptyCart: 'Cart is empty',
  emptyCartDescription: 'Add items to your cart to get started',
  estimatedDate: 'Estimated date',
  handoverNotes: 'Handover notes',
  handoverNotesForVendor: 'Notes to vendor (Optional)',
  handoverNotesPlaceholder: 'Anything you need to tell to the vendor.',
  initial: 'Initial',
  initialPayment: 'Initial',
  itemDetail: 'Item Detail',
  itemList: 'Item List',
  itemsInCart: 'Items in cart',
  licenseStore: 'License Store',
  lineNumber: 'Line Number',
  markAsReceived: 'Mark as Received',
  markAsReceivedDescription:
    'Mark the all product of this order as received.\nThis action cannot be undone.',
  markAsReceivedOkButton: 'Execute',
  marketplace: 'Marketplace',
  marketplaceUnavailable: 'Marketplace Unavailable',
  marketplaceUnavailableDescription:
    'Sorry, but the marketplace is currently unavailable. Please contact the administrator.',
  newPlaceName: 'Place name',
  newPlaceNamePlaceholder: 'Type place name...',
  oneshot: 'Initial',
  orderer: 'Orderer',
  orders: 'Orders',
  payment: 'Payment',
  period: 'Period',
  place: 'Place',
  placeOrder: 'Place order',
  pleaseSelectAllRequiredOptions: 'Please select all required options',
  priceRange: 'Price Range',
  productNotFound: 'Product not found',
  purchase: 'Purchase',
  quantity: 'Quantity',
  quantityUpdated: 'Quantity updated',
  quotation: 'Quotation required',
  quotationRequired: 'Quotation required',
  recurring: 'Recurring',
  recurringPayment: 'Recurring',
  registerNewPlace: 'Save the address to reuse as place',
  rental: 'Rental',
  requestDate: 'Request date',
  requestSent: 'Request sent',
  searchByFreeTextPlaceholder: 'Search by free text',
  searchCustomerPlaceholder: 'Search Customer...',
  searchOrdersPlaceholder: 'Filter orders...',
  selectPlaceOrEnterAddress:
    'Select place or manually enter a valid address form',
  selectPlacePlaceholder: 'Select a place...',
  shipping: 'Shipping',
  status: 'Status',
  store: 'Device Store',
  subtotal: 'Subtotal',
  successfullyRemovedFromCart: 'Successfully removed from cart',
  tax: 'Tax',
  taxPerUnit: 'Tax per Unit',
  total: 'Total',
  totalPrice: 'Total Price',
  unitPrice: 'Unit Price',
  validationError: 'Validation Error',
  variantNotFound: 'Product variant not found',
  vendor: 'Vendor',
};

export default pagesMarketplaceEn;
